module.exports = __webpack_public_path__ + "static/media/26-4.37b38578.mp3";